// 색상 매핑 의도:
// - 위험도 순으로 빨강 → 주황 → 노랑(PRHC/DNGC/RESC)을 배치해 의미적 그라데이션 유지
// - 나머지 6개(MOAC, UAC, CTRC, FLDC, CATC, ATZC)는 라임~핑크까지 색상환을 한 바퀴 돌도록 분산 → 인접 구역끼리도 색이 겹치지 않음

// prettier-ignore
const GEO_ZONES = {
  UAC:  { color: '#00E676', title: '초경량비행장치비행공역' },
  CTRC: { color: '#00E5FF', title: '관제권' },
  PRHC: { color: '#FF2D2D', title: '비행금지구역' },
  RESC: { color: '#FFE600', title: '비행제한구역' },
  ATZC: { color: '#FF4FCF', title: '비행장교통구역' },
  DNGC: { color: '#FF8C00', title: '위험구역' },
  MOAC: { color: '#B2FF1A', title: '군작전구역' },
  CATC: { color: '#B14CFF', title: '훈련구역' },
  FLDC: { color: '#2979FF', title: '경량항공기이착륙장' },
};

export default GEO_ZONES;
